/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_EyebrowInputs */

const es_ab_eyebrow = /** @type {(inputs: Ab_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publica tu barco`)
};

const gl_ab_eyebrow = /** @type {(inputs: Ab_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publica o teu barco`)
};

const en_ab_eyebrow = /** @type {(inputs: Ab_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List your boat`)
};

/**
* | output |
* | --- |
* | "List your boat" |
*
* @param {Ab_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_eyebrow = /** @type {((inputs?: Ab_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_eyebrow(inputs)
	if (locale === "en") return en_ab_eyebrow(inputs)
	return es_ab_eyebrow(inputs)
});